import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import { jsx } from 'react/jsx-runtime';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef, useCallback } from 'react';
import { composeEventHandlers } from '../../utils/composeEventHandlers.js';
import styles from './dropdown-menu.module.js';
/**
 * Based on Radix-UI [DropdownMenu Item](https://www.radix-ui.com/docs/primitives/components/dropdown-menu#item)
 */

var DropdownMenuItem = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var preventDefault = useCallback(function (event) {
    return event.preventDefault();
  }, []);
  return jsx(DropdownMenuPrimitive.Item, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: styles.item,
    onPointerLeave: composeEventHandlers(props.onPointerLeave, preventDefault),
    onPointerMove: composeEventHandlers(props.onPointerMove, preventDefault),
    // If click starts at trigger button, and ends on the item, it should not trigger the item.
    // Note: this also has a side effect of not allowing to start click and end on a different time.
    // TODO: see if possible to make https://github.com/radix-ui/primitives/blob/b32a93318cdfce383c2eec095710d35ffbd33a1c/packages/react/menu/src/Menu.tsx#L646
    onPointerUp: composeEventHandlers(props.onPointerUp, preventDefault),
    children: jsx("span", {
      className: styles.ellipsis,
      children: children
    })
  }));
});
DropdownMenuItem.displayName = 'DropdownMenuItem';
export { DropdownMenuItem };